import type {
  ParseRentRollResponse,
  CreateRentRollAttributes,
  RentRollAttributes,
  LeaseData
} from 'common'
import { coreClient } from './coreclient'

async function parseRentRoll(
  file: File,
  type: 'pdf' | 'excel' | 'csv',
  maxMode = false
): Promise<ParseRentRollResponse> {
  const client = await coreClient()
  return await client.rentroll.parseRentRoll(type, { file }, maxMode)
}

async function saveRentRoll(rentRoll: CreateRentRollAttributes): Promise<RentRollAttributes> {
  const client = await coreClient()
  const response = await client.rentroll.saveRentRoll(rentRoll)
  return response.data
}

async function listRentRolls(): Promise<RentRollAttributes[]> {
  const client = await coreClient()
  const response = await client.rentroll.listRentRolls()
  return response.data
}

async function getRentRoll(
  id: number,
  options?: { logVisit?: boolean }
): Promise<RentRollAttributes> {
  const client = await coreClient()
  const response = await client.rentroll.getRentRollById(id, options?.logVisit)
  return response.data
}

async function updateRentRoll(
  id: number,
  data: {
    name?: string
    lease_data?: LeaseData[]
    as_of_date?: Date | null
    metadata?: Record<string, unknown> | null
    reviewed?: boolean
  }
): Promise<RentRollAttributes> {
  const client = await coreClient()

  // Convert Date to string for API
  const apiData = {
    ...data,
    as_of_date: data.as_of_date ? data.as_of_date.toISOString() : data.as_of_date
  }

  const response = await client.rentroll.updateRentRoll(id, apiData)
  return response.data
}

async function deleteRentRoll(id: number): Promise<RentRollAttributes> {
  const client = await coreClient()
  const response = await client.rentroll.deleteRentRoll(id)
  return response.data
}

async function getRentRollFile(id: number): Promise<string> {
  const client = await coreClient()
  const response = await client.rentroll.getRentRollFile(id)
  return response.data
}

export default {
  parseRentRoll,
  saveRentRoll,
  listRentRolls,
  getRentRoll,
  updateRentRoll,
  deleteRentRoll,
  getRentRollFile
}
